<template lang="pug">
tbody.tableTop10-tbody.tableTop10-tbody--2
  tr(@click="goTo(idx)" v-if="infos" v-for='(info, idx) in infos' :key='idx')
    td.tableTop10-innerText--2 {{ info.article.id }}
    td.tableTop10-innerText--main
      .tableTop10-contentRight2
        v-clamp.tableTop10-text2.color--black60(autoresize :max-lines="2") {{ info.article.content }}
      .tableTop10-preview(v-if="!!info.article.thumbnailUrl")
        img.tableTop10-previewImage(:src="info.article.thumbnailUrl")
        v-clamp.tableTop10-previewText.tableTop10-text2.color--black30(autoresize :max-lines="2") {{ info.article.urlContent }}
    td.tableTop10-innerText--2.tableTop10-innerText--center {{ info.article.updatedAtStr }}
    td.tableTop10-innerText--2.tableTop10-innerText--center.show--bigScreens {{ info.article.reporterCount }}
</template>
<script>
import VClamp from 'vue-clamp';

export default {
  components: {
    VClamp
  },
  props: {
    infos: Array
  },
  methods: {
    goTo(idx) {
      this.$router.push({
        path: '/news',
        query: {
          categoryId: this.infos[idx].article.category.id,
          articleId: this.infos[idx].article.id
        }
      });
    }
  }
};
</script>
